module.exports = __webpack_public_path__ + "static/media/ic_kran_active.b81a47d0.png";